import { ExtractoPasajero } from '../model/ExtractoPasajero.model';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExtractoPasajerosService {
  // Aquí irían los métodos para interactuar con la API, como listar, crear, actualizar, eliminar pasajeros.
   private apiUrl = `${environment.apiUrl}/api/extracto-pasajeros`;

   constructor(private http: HttpClient) {}

  listarPasajeros(extractoId: number) {
  return this.http.get(
    `${this.apiUrl}/${extractoId}/pasajeros`
  );
}
 
   crear( pasajero: ExtractoPasajero) {
     return this.http.post<ExtractoPasajeroResponse>(`${this.apiUrl}/pasajeros`, pasajero);
   }

 actualizar(
  extractoId: number,
  pasajeroId: number,
  pasajero: ExtractoPasajero
) {
  return this.http.put<ExtractoPasajeroResponse>(
    `${this.apiUrl}/${extractoId}/pasajeros/${pasajeroId}`,
    pasajero
  );
}
 
eliminar(extractoId: number, pasajeroId: number) {
  return this.http.delete<ExtractoPasajeroResponse>(
    `${this.apiUrl}/${extractoId}/pasajeros/${pasajeroId}`
  );
}
}



export interface ExtractoPasajeroResponse {
  codigo: number;
  mensaje: string;
  data: ExtractoPasajero | ExtractoPasajero[];
}